let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aVj0b")).then(() => parcelRequire('42yuB'));